function stepTwoReducer(state = {
    redirectToValidateOrFinish:false,
    modal:false,
    url:'',
    isValid:false,
}, action) {
  switch (action.type) {
    case 'SET_REDIRECT':
      return {
        ...state,
        redirectToValidateOrFinish: action.redirectToValidateOrFinish,
      };
      case 'SET_URL':
        return {
          ...state,
          url: action.url,
        };
        case 'SET_MODAL':
        return {
          ...state,
          modal: action.modal,
        };
        case 'SET_ISVALID':
          return {
            ...state,
            isValid: action.isValid,
          };
    default:
      return state;
  }
}


export default stepTwoReducer 





// WEBPACK FOOTER //
// src/reducers/stepTwoReducer.js